import {useCallback, useMemo} from "react"
import {Dimensions} from "react-native"
import isExpo from "@kaspernj/api-maker/build/is-expo"
import useBreakpoint from "@kaspernj/api-maker/build/use-breakpoint"
import useCurrentUser from "@kaspernj/api-maker/build/use-current-user"
import useEventListener from "@kaspernj/api-maker/build/use-event-listener"
import useShape from "set-state-compare/build/use-shape"

const menuExtraSize = 310

const breakpointsWithExtraMenuSize = [
  ["xxl", 1400 + menuExtraSize],
  ["xl", 1200 + menuExtraSize],
  ["lg", 992 + menuExtraSize],
  ["md", 768 + menuExtraSize],
  ["sm", 576 + menuExtraSize],
  ["xs", 0]
]

const breakpointsWithoutExtraMenuSize = [
  ["xxl", 1400],
  ["xl", 1200],
  ["lg", 992],
  ["md", 768],
  ["sm", 576],
  ["xs", 0]
]

const showMenuSize = 992

const useShowMenu = () => {
  const currentUser = useCurrentUser()
  const s = useShape({currentUser})

  s.meta.breakpoint = useBreakpoint()

  const calculateShowMenu = useCallback(() => {
    // Use 'window.innerWidth' outside Expo because sometimes window width excludes scroll
    const windowWidth = isExpo ? Dimensions.get("window").width : window.innerWidth
    let showMenu = false
    let size

    if (windowWidth >= showMenuSize && s.p.currentUser) {
      showMenu = true
    }

    if (s.m.breakpoint.mdUp) {
      size = 240
    } else {
      size = 190
    }

    return {size, showMenu}
  }, [])

  s.useStates({
    size: calculateShowMenu().size,
    showMenu: () => calculateShowMenu().showMenu
  })

  const recalculateShowMenu = useCallback(() => {
    const {size, showMenu} = calculateShowMenu()

    s.set({size, showMenu})
  }, [])

  useEventListener(Dimensions, "change", recalculateShowMenu)

  const result = useMemo(() => ({
    size: s.s.size,
    showMenu: s.s.showMenu
  }), [s.s.showMenu])

  return result
}

export {breakpointsWithExtraMenuSize, breakpointsWithoutExtraMenuSize}
export default useShowMenu
